import React from "react";

const About: React.FC = () => {
  return (
    <div className="">
      <h1 className="text-3xl font-bold">About Page</h1>
      <p>Learn more about us on this page.</p>
    </div>
  );
};

export default About;
